<template>
  <el-dialog
    class="order-split-modal"
    width="90%"
    title="订单项目拆分"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <form v-loading="loading" class="respone-form">
      <div class="field">
        拆分编号{{ context.sn }}
      </div>
      <div class="field">
        <el-input-number
          v-model="context.splitCount"
          placeholder="拆分数量"
          :controls="false"
          :step="1"
          :step-strictly="true"
          :min="1"
          :max="context.quantity - context.quantityDelivered"
        />
      </div>
      <div class="actions">
        <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
        <el-button type="default" size="small" @click="close(false)">取消</el-button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { SplitOrderItem } from '../services'
import _ from 'lodash'
export default {
  name: 'SplitOrderModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      context: {
        orderItemId: '',
        sn: '',
        quantity: 0,
        quantityDelivered: 0,
        splitCount: undefined
      }
    }
  },
  created () {
    this.debounceRequest = _.debounce(() => {
      const { orderItemId, splitCount } = this.context
      SplitOrderItem({
        orderItemId,
        splitCount
      }).then((resp) => {
        this.$message.success(JSON.stringify(resp.data))
        this.close(true)
      })
    }, 5000, {
      leading: true,
      trailing: false
    })
  },
  methods: {
    init ({ orderItemId, sn, quantity, quantityDelivered }) {
      console.log(orderItemId, sn, quantity, quantityDelivered)
      this.context.orderItemId = orderItemId
      this.context.sn = sn
      this.context.quantity = quantity
      this.context.quantityDelivered = quantityDelivered
      return this.open()
    },
    checkModel () {
      return new Promise((resolve, reject) => {
        const { quantity, splitCount } = this.context
        if (!splitCount) reject(new Error('请输入拆分数量'))
        if (quantity - splitCount <= 0) {
          reject(new Error('不能全量拆分'))
        }
        resolve(true)
      })
    },
    doSubmit () {
      this.checkModel().then(() => {
        this.debounceRequest()
      }).catch((err) => {
        this.$message.error(err.message)
      })
    }
  }
}
</script>
<style lang="stylus">
.order-split-modal
  .el-dialog
    max-width 800px
    .el-dialog__body
      padding-top 10px
      .field
        .el-input-number
          width 100%
          input
            text-align left
        +.field
          margin-top 12px
    .actions
      margin-top 12px
      text-align center
</style>
